// Khung log. Tu cuon xuong duoi, tru khi nguoi dung dang cuon len doc lai.

import { useEffect, useRef, useState } from "react";
import type { LogLine, RunMeta } from "../types";
import { StatusBadge } from "./ui";

// Mau cho tung trang thai mat xich trong chuoi.
const MAU: Record<string, string> = {
  cho: "#5d6675",
  running: "#6ea8fe",
  success: "#7fd3a4",
  failed: "#ff8b8b",
  cancelled: "#e5a25a",
  bo_qua: "#4a515e",
};

const NHAN: Record<string, string> = {
  cho: "chờ",
  running: "đang chạy",
  success: "xong",
  failed: "hỏng",
  cancelled: "đã dừng",
  bo_qua: "bỏ qua",
};

/** Dai tien do cua lan chay noi tiep nhieu buoc. */
function TienDoChuoi({ run }: { run: RunMeta }) {
  if (!run.la_chuoi || !run.chuoi?.length) return null;
  return (
    <div
      style={{
        display: "flex", gap: 6, flexWrap: "wrap", padding: "8px 13px",
        background: "#141821", borderBottom: "1px solid #262c38", fontSize: 11.5,
      }}
    >
      {run.chuoi.map((b, i) => (
        <span
          key={b.step_id}
          title={`${b.label} — ${NHAN[b.status] ?? b.status}`}
          style={{
            color: MAU[b.status] ?? "#5d6675",
            border: `1px solid ${b.status === "running" ? "#6ea8fe" : "#2b3140"}`,
            borderRadius: 20, padding: "1px 9px", whiteSpace: "nowrap",
            fontWeight: b.status === "running" ? 600 : 400,
          }}
        >
          {i + 1}. {b.label.replace(/^\d+\.\s*/, "")} · {NHAN[b.status] ?? b.status}
        </span>
      ))}
    </div>
  );
}

export default function Console({
  log,
  run,
  onCancel,
  dangChay,
  trangThaiNoi,
}: {
  log: LogLine[];
  run: RunMeta | null;
  onCancel?: () => void;
  dangChay: boolean;
  trangThaiNoi?: string;
}) {
  const boxRef = useRef<HTMLDivElement>(null);
  const [tuCuon, setTuCuon] = useState(true);

  useEffect(() => {
    if (!tuCuon) return;
    const el = boxRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [log, tuCuon]);

  const khiCuon = () => {
    const el = boxRef.current;
    if (!el) return;
    // Coi la "dang o duoi cung" khi con cach day duoi duoi 40px.
    setTuCuon(el.scrollHeight - el.scrollTop - el.clientHeight < 40);
  };

  return (
    <div className="console grow">
      <div className="console-head">
        <span style={{ fontWeight: 600 }}>Nhật ký chạy</span>
        {run ? <StatusBadge status={run.status} /> : null}
        {run?.exit_code != null ? (
          <span className="mono" style={{ color: "#7f8797" }}>exit {run.exit_code}</span>
        ) : null}
        <span className="grow" />
        {trangThaiNoi === "mat-ket-noi" ? (
          <span style={{ color: "#e5a25a" }}>mất kết nối, đang hỏi lại</span>
        ) : null}
        <span style={{ color: "#5d6675" }}>{log.length} dòng</span>
        {!tuCuon && (
          <button
            className="btn btn-sm btn-ghost"
            style={{ color: "#c9d1de" }}
            onClick={() => setTuCuon(true)}
          >
            ↓ Xuống cuối
          </button>
        )}
        {dangChay && onCancel ? (
          <button className="btn btn-sm btn-danger" onClick={onCancel}>
            Dừng
          </button>
        ) : null}
      </div>

      {run ? <TienDoChuoi run={run} /> : null}

      <div className="console-body" ref={boxRef} onScroll={khiCuon}>
        {log.length === 0 && run && run.so_dong > 0 ? (
          // Lan chay co that nhung file .log da bi don di - noi ro ra, dung de
          // nguoi dung tuong la chua chay bao gio.
          <div>
            <div style={{ color: "#e5a25a" }}>
              Nhật ký chi tiết của lần chạy này không còn trên đĩa (đã bị dọn).
              Lúc chạy có {run.so_dong} dòng.
            </div>
            {run.dong_cuoi?.length ? (
              <>
                <div style={{ color: "#5d6675", marginTop: 10 }}>Những dòng cuối ghi nhận được:</div>
                {run.dong_cuoi.map((t, i) => (
                  <div key={i} className="console-line">
                    <span className="lt">·</span>
                    <span>{t}</span>
                  </div>
                ))}
              </>
            ) : (
              <div style={{ color: "#5d6675", marginTop: 10 }}>
                Lần chạy này có từ trước khi bản ghi dòng cuối được thêm, nên không còn lý do.
                Chạy lại bước đó để xem lỗi đầy đủ.
              </div>
            )}
          </div>
        ) : log.length === 0 ? (
          <div style={{ color: "#5d6675" }}>Chưa có nhật ký. Chọn một bước rồi bấm Chạy.</div>
        ) : (
          log.map((l) => (
            <div key={l.n} className={`console-line k-${l.kind}`}>
              <span className="lt">{l.t}</span>
              <span>{l.text}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
